import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: scssVariables.BorderRadiusMedium,
      minHeight: 'var(--input-height-small) !important', // Mui sets it back to auto in some cases, so we need to force it
      padding: theme.spacing(1, 1),
      gap: theme.spacing(1),

      '&:not(:first-child)': {
        marginTop: theme.spacing(0.5), // make sure focus outline is not cut off in list
      },

      '&.Mui-selected': {
        backgroundColor: scssVariables.ColorFog20,

        '&:hover': {
          backgroundColor: scssVariables.ColorFog40,
        },
        '&:focus:not(:hover)': {
          backgroundColor: scssVariables.ColorFog40,
        },
      },

      '&:hover:not(.Mui-selected), &:focus:not(.Mui-selected)': {
        backgroundColor: scssVariables.ColorFog20,
      },
    }),
  },
};
